module.exports = __webpack_public_path__ + "static/media/doc.247b7086.svg";